import React from 'react';
import faker from 'faker';
import Chart from '../../../../components/organisms/chart';
import useRenderChartClient from './hooks';

interface Props {
    currentClient: {value: number, label: string} | null;
    currentVm: {value: number, label: string} | null;
}

function RenderChartClient(props: Props) {
  const { currentClient, currentVm } = props;
  const {
    currentView, setCurrentView, salesData, isLoading, isDataExists,
  } = useRenderChartClient(currentClient, currentVm);
  const { CustomTopContent, Default } = Chart.Overview;

  return (
    <Default
      title="Weekly Sales"
      topContent={[
        CustomTopContent('Today', faker.datatype.number({ min: -10, max: 10 }), salesData?.total?.today),
        CustomTopContent('This Week', faker.datatype.number({ min: -10, max: 10 }), salesData?.total?.week),
        CustomTopContent('This Month', faker.datatype.number({ min: -10, max: 10 }), salesData?.total?.oneMonth),
        CustomTopContent('3 Months', faker.datatype.number({ min: -10, max: 10 }), salesData?.total?.threeMonth),
        CustomTopContent('6 Months', faker.datatype.number({ min: -10, max: 10 }), salesData?.total?.sixMonth),
        CustomTopContent('1 Year', faker.datatype.number({ min: -10, max: 10 }), salesData?.total?.year),
      ]}
      items={[
        { label: 'Soda', bgColor: 'rgb(117, 192, 219)', amount: salesData?.data?.soda ?? [] },
        { label: 'Snack', bgColor: 'rgb(225, 143, 80)', amount: salesData?.data?.snack ?? [] },
      ]}
      currentView={currentView}
      setCurrentView={setCurrentView}
      labels={salesData?.data?.label ?? []}
      isData={isDataExists}
      isLoading={isLoading}
    />
  );
}

export default React.memo(RenderChartClient);
